<div class="powered-by">
  🛒 Powered by <a href="https://www.google.com/" target="_blank">
    Slick Cart</a
  >
</div>

<style lang="scss">
  .powered-by {
    color: #3f3f3f;
    font-size: 0.66rem;
    text-align: center;
  }

  .powered-by > a {
    // text-decoration: underline;
    color: #000;
    font-size: inherit;
    font-weight: 600;
  }
</style>
